<template>
  <v-row class="login-page align-center">
    <v-col class="login_page">
      <v-row>
        <v-col sm="6">
          <v-row>
            <v-col class="login-page_img">
              <h1
                ><strong>Qentelli</strong>
                License Manager
              </h1>
            </v-col>
          </v-row>
        </v-col>
        <v-col offset-sm="1" sm="4" class="ma-10 pa-10">
          <form>
            <v-row class="flex-column">
              <v-col class="login_form__fields">
                <slot />
              </v-col>
            </v-row>
          </form>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      isMobile: 'vuetify/isMobile',
    }),
  },
};
</script>

<style lang="scss">
@import '../assets/scss/colors.scss';
.login-page {
  min-height: 100vh;
  &_img {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px;
    min-height: 100vh;
    text-align: center;
    color: $white;
    background: url('../assets/img/login-bg.png');

    h1 {
      font-size: 46px;
      font-size: 40px;
      font-weight: 300;
      letter-spacing: 0.58px;

      strong {
        display: block;
        font-weight: 600;
      }
    }
  }
  h2 {
    font-size: 24px;
    line-height: 35px;
  }
  .forgot-pwd {
    a {
      text-decoration: none;
      color: #303361;
    }
  }
}
</style>
